import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import {
  selectCurrentContent,
  selectProgress,
} from "../../redux/selectors/playerSelector";

/**
 * Отслеживает прогресс прослушивания подкаста и отправляет
 * последние данные на сервер при закрытии/обновлении страницы.
 */
const sendProgressBeacon = (data) => {
  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    return;
  }

  // Использует keepalive: true для работы при закрытии страницы
  fetch("/api/podcasts/tracks/duration", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(data),
    keepalive: true,
  });
};

/**
 * Сохраняет прогресс воспроизведения при закрытии / обновлении страницы и каждые 10 секунд
 */
export const usePlaybackProgress = (intervalMs = 10000) => {
  const progressPlayer = useSelector(selectProgress);
  const currentContentPlayer = useSelector(selectCurrentContent);

  const latestDataRef = useRef({ progressPlayer, currentContentPlayer });
  const lastSavedProgressRef = useRef(null);

  useEffect(() => {
    latestDataRef.current = { progressPlayer, currentContentPlayer };
  }, [progressPlayer, currentContentPlayer]);

  useEffect(() => {
    const saveData = () => {
      const {
        progressPlayer: latestProgress,
        currentContentPlayer: latestContent,
      } = latestDataRef.current;

      if (
        !latestContent?.id ||
        !latestContent?.podcastId ||
        latestProgress === lastSavedProgressRef.current
      ) {
        return;
      }

      sendProgressBeacon({
        duration: latestProgress,
        podcast_id: latestContent.podcastId,
        podcast_track_id: latestContent.id,
      });

      lastSavedProgressRef.current = latestProgress;
    };

    const intervalId = setInterval(saveData, intervalMs);

    window.addEventListener("unload", saveData);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("unload", saveData);
    };
  }, [intervalMs]);
};
